export const QUICK_FILTER_TYPE = {
    time:[
        {label:'Equals To',value:'equals'},
        {label:'Not Equals To',value:'notEquals'},
        {label:'Before Date',value:'beforeDate'},
        {label:'After Date',value:'afterDate'},
        {label:'In Date Range',value:'inDateRange'},
        {label:'Not In Date Range',value:'notInDateRange'},
        {value:"set", label:"Exclude Null"},
        {value:"notSet", label:"Only Null"}
    ],
    number:[
        {label:'Equals To',value:'equals'},
        {label:'Not Equals To',value:'notEquals'},
        {label:'Greater Than',value:'gt'},
        {label:'Greater Than or Equals To',value:'gte'},
        {label:'Less Than',value:'lt'},
        {label:'Less Than or Equals To',value:'lte'},
        {label:'Between',value:'bw'},
        {value:"set", label:"Exclude Null"},
        {value:"notSet", label:"Only Null"}
    ],
    count:[
        {label:'Equals To',value:'equals'},
        {label:'Not Equals To',value:'notEquals'},
        {label:'Greater Than',value:'gt'},
        {label:'Greater Than or Equals To',value:'gte'},
        {label:'Less Than',value:'lt'},
        {label:'Less Than or Equals To',value:'lte'},
        {label:'Between',value:'bw'},
        {value:"set", label:"Exclude Null"},
        {value:"notSet", label:"Only Null"}
    ],
    string:[
        {label:'Equals To',value:'equals'},
        {label:'Not Equals To',value:'notEquals'},
        {label:'Contains',value:'contains'},
        {label:'Does Not Contains',value:'notContains'},
        {label:'Starts With',value:'startsWith'},
        {label:'Ends With',value:'endsWith'},
        {value:"set", label:"Exclude Null"},
        {value:"notSet", label:"Only Null"}
    ]
}